import { GlobalStyles as MuiGlobalStyles } from '@mui/material';

/**
 * Global styles for the application
 * These styles complement the Material-UI theme
 */
export const GlobalStyles = () => (
  <MuiGlobalStyles
    styles={{
      '*': {
        boxSizing: 'border-box',
        margin: 0,
        padding: 0,
      },
      html: {
        WebkitFontSmoothing: 'antialiased',
        MozOsxFontSmoothing: 'grayscale',
        height: '100%',
        width: '100%',
      },
      body: {
        height: '100%',
        width: '100%',
        overflowX: 'hidden',
        transition: 'font-size 0.3s ease, background-color 0.3s ease, color 0.3s ease',
      },
      '#root': {
        height: '100%',
        width: '100%',
      },
      a: {
        textDecoration: 'none',
        color: 'inherit',
      },
      'a:hover': {
        textDecoration: 'none',
      },
      img: {
        maxWidth: '100%',
        height: 'auto',
        display: 'block',
      },
      'input:focus, textarea:focus, select:focus': {
        outline: 'none',
      },
      '.main': {
        minHeight: 'calc(100vh - 400px)',
      },
      // Accessibility: Font Size Classes
      'html.font-normal': {
        fontSize: '100%',
      },
      'html.font-medium': {
        fontSize: '112.5%', // 18px base
      },
      'html.font-large': {
        fontSize: '125%', // 20px base
      },
      'body.font-normal, body.font-medium, body.font-large': {
        fontSize: '1rem',
      },
      // Accessibility: High Contrast Mode
      'body.high-contrast': {
        backgroundColor: '#000000 !important',
        color: '#FFFFFF !important',
        filter: 'contrast(1.5)',
      },
      'body.high-contrast a': {
        color: '#FFFF00 !important',
        textDecoration: 'underline',
      },
      'body.high-contrast button': {
        backgroundColor: '#FFFFFF !important',
        color: '#000000 !important',
        border: '2px solid #FFFFFF !important',
      },
      'body.high-contrast .MuiCard-root': {
        backgroundColor: '#1a1a1a !important',
        color: '#FFFFFF !important',
        border: '2px solid #FFFFFF !important',
      },
      'body.high-contrast .MuiPaper-root': {
        backgroundColor: '#1a1a1a !important',
        color: '#FFFFFF !important',
      },
      'body.high-contrast .MuiTypography-root': {
        color: '#FFFFFF !important',
      },
      'body.high-contrast input, body.high-contrast textarea, body.high-contrast select': {
        backgroundColor: '#000000 !important',
        color: '#FFFFFF !important',
        border: '2px solid #FFFFFF !important',
      },
      'body.high-contrast .MuiOutlinedInput-root': {
        backgroundColor: '#000000 !important',
        color: '#FFFFFF !important',
      },
      'body.high-contrast .MuiOutlinedInput-notchedOutline': {
        borderColor: '#FFFFFF !important',
      },
      'body.high-contrast .MuiInputBase-input': {
        color: '#FFFFFF !important',
      },
      'body.high-contrast .MuiIconButton-root': {
        color: '#FFFFFF !important',
      },
      'body.high-contrast .MuiChip-root': {
        backgroundColor: '#333333 !important',
        color: '#FFFFFF !important',
        border: '1px solid #FFFFFF !important',
      },
      'body.high-contrast img': {
        filter: 'contrast(1.2) brightness(0.9)',
      },
    }}
  />
);
